module.exports = __webpack_public_path__ + "static/media/bg-header.e51f57b3.png";